;(function($, window) {
    'use strict';
    $.plugin('searchsuggester', {
        defaults: {
            'triggerElSelector': 'input[name="search"]',
            'language':'/de',
            'jsonResultNode':'suggestions',
            'optionsArray':[],
            'suggestionUpdatedEvent':'updateSuggestions',
        },
        init: function () {
            var me = this;
            me.opts = $.extend(true, {}, me.opts, me.$el.data());
            me.initSuggester(me.$el,me.opts);
        },
        initSuggester: function($searchInputField,opts){
            var me = this;
            if(opts.autocompleteList && opts.autocompleteList.length > 0){
                opts.optionsArray = opts.autocompleteList.split(',');
            }
            opts.url = opts.requestFile;
            var suggestionCallback = function(data){
                var json = data;
                var options = json[opts.jsonResultNode];
                if(options.length > 0){
                    for(var i in options){
                        var value = options[i];
                        if(opts.optionsArray.indexOf(value) === -1){
                            opts.optionsArray.push(value);
                        }
                    }
                    $searchInputField.trigger(opts.suggestionUpdatedEvent);
                }
            };

            var getSuggestion = function(inputValue){
                opts.dataType = "json";
                opts.suggestText = inputValue;
                me.onFetch(opts,suggestionCallback);
            };

            $searchInputField.on("input", function(e){
                var inp = e.currentTarget;
                var inputValue = $(inp).val();
                getSuggestion(inputValue);
            });
            me.autocomplete($searchInputField[0]);
        },
        onFetch: function (opts, callback){
            var data = {
                search: opts.suggestText,
                language:opts.language
            };
            data = $.extend(true, {}, data, opts.filter);
            var request = {
                type: 'GET',
                url: opts.url,
                dataType: opts.dataType,
                data: data,
                opts: opts
            };
            window.ContentFetcher.fetch(request, callback);
        },
        autocomplete: function (inp) {
            var me = this;
            var currentFocus;

            var updateSuggestions = function(e) {
                var $inp = $(inp);
                var a, b, i, val = $inp.val();
                /*close any already open lists of autocompleted values*/
                closeAllLists();
                if (!val) { return false;}
                currentFocus = -1;
                var suggestions = me.opts.optionsArray;

                /*create an element that will contain the items (values):*/
                var $ul = $('<ul class="ui-menu ui-widget ui-widget-content ui-autocomplete ui-front" tabindex="0"></ul>')
                $ul.attr("id", $inp.attr('id') + "autocomplete-list");
                $ul.addClass("autocomplete-items");
                /*append the DIV element as a child of the autocomplete container:*/
                $(inp).after($ul);
                /*for each item in the array...*/
                for (i = 0; i < suggestions.length; i++) {
                    /*check if the item starts with the same letters as the text field value:*/
                    if (suggestions[i].substr(0, val.length).toUpperCase() == val.toUpperCase()) {
                        /*create a DIV element for each matching element:*/
                        var $li = $('<li class="ui-menu-item">');
                        var $a = $('<a tabindex="-1" class="ui-menu-item-wrapper"></a>');
                        /*make the matching letters bold:*/
                        $a.html("<b>" + suggestions[i].substr(0, val.length) + "</b>"
                            + suggestions[i].substr(val.length)
                            + "<input type='hidden' value='" + suggestions[i] + "'>");
                        /*execute a function when someone clicks on the item value (DIV element):*/
                        $li.append($a);
                        $li.on("click", function(e) {
                            /*insert the value for the autocomplete text field:*/
                            $(inp).val($(e.currentTarget).find("input").eq(0).val());
                            /*close the list of autocompleted values,
                            (or any other open lists of autocompleted values:*/
                            closeAllLists();
                        });
                        $ul.append($li);
                    }
                }
            };
            /*execute a function when someone writes in the text field:*/
            $(inp).on(me.opts.suggestionUpdatedEvent, updateSuggestions);
            $(inp).on('keyup', function(e) {
                e.preventDefault();
                if(e.keyCode == 40 || e.keyCode == 38 || e.keyCode == 13){
                    //reserved for other event handlers
                }else{
                    updateSuggestions(e);
                }
            });
            /*execute a function presses a key on the keyboard:*/
            inp.addEventListener("keydown", function(e) {
                var $ul = $('.autocomplete-items');
                var $listItems = $ul.find('li');
                if (e.keyCode == 40) {
                    e.preventDefault();
                    /*If the arrow DOWN key is pressed,
                    increase the currentFocus variable:*/
                    currentFocus++;
                    /*and and make the current item more visible:*/
                    addActive($listItems);
                } else if (e.keyCode == 38) { //up
                    e.preventDefault();
                    /*If the arrow UP key is pressed,
                    decrease the currentFocus variable:*/
                    currentFocus--;
                    /*and and make the current item more visible:*/
                    addActive($listItems);
                } else if (e.keyCode == 13) {
                    if (currentFocus > -1 && currentFocus < $listItems.length ) {
                        e.preventDefault();
                        /*and simulate a click on the "active" item:*/
                        $listItems.eq(currentFocus).click();
                    }
                }
            });
            function addActive($listItems) {
                /*a function to classify an item as "active":*/
                if ($listItems.length === 0) return false;
                /*start by removing the "active" class on all items:*/
                removeActive($listItems);
                if (currentFocus >= $listItems.length) currentFocus = 0;
                if (currentFocus < 0) currentFocus = ($listItems.length - 1);
                /*add class "autocomplete-active":*/
                $listItems.eq(currentFocus).addClass("autocomplete-active");
            }
            function removeActive($listItems) {
                /*a function to remove the "active" class from all autocomplete items:*/
                for (var i = 0; i < $listItems.length; i++) {
                    $listItems.eq(i).removeClass("autocomplete-active");
                }
            }
            function closeAllLists(elmnt) {
                /*close all autocomplete lists in the document,
                except the one passed as an argument:*/
                var $ul = $('.autocomplete-items');
                var $listItems = $ul.find('li');
                for (var i = 0; i < $listItems.length; i++) {
                    if (elmnt != $listItems[i] && elmnt != inp) {
                        $listItems[i].parentNode.removeChild($listItems[i]);
                    }
                }
            }
            /*execute a function when someone clicks in the document:*/
            document.addEventListener("click", function (e) {
                closeAllLists(e.target);
            });
        },
        destroy: function () {
            var me = this;
            me._destroy();
        }
    });
})(jQuery, window);
